import React from 'react';

import { ErrorGlobal } from '@xingternal/content-error';
import { useSelector } from 'react-redux';

import { AppRoutes } from '../../../RoutesConfig';
import { PageSections } from '../../shared';
import { AdminNavigation } from './AdminNavigation';
import styles from './TermsOverview.css';
import { RootState } from '../../../redux';

export const AdminTermsOverview = (): React.ReactElement => {
  const { entity: pages, error } = useSelector<
    RootState,
    RootState['adminPages']
  >(state => {
    return state.adminPages;
  });

  return (
    <>
      <div className={styles.overviewContainer}>
        <AdminNavigation />

        {error && <ErrorGlobal type="503" />}

        {pages && (
          <PageSections
            pages={pages}
            pageLink={page =>
              AppRoutes.admin.adminTermsOverview(
                page.slug,
                page.lastVersionId,
                'en'
              )
            }
          />
        )}
      </div>
    </>
  );
};
